import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import noImg from "../../assets/img/No_Image.png";
import { BaseUrlFiles } from "../../Constant/Config";
const ChartSidebar = (props) => {

  var labelArray = [];
  props.data?.props.topUser?.map(
    (chart) =>
      chart?.skillChart?.map((userChart) => labelArray?.push(userChart.month))
  );
  var lastArrayInApi;
  lastArrayInApi = props.data?.props.topUser.slice(0, 5);
  if (props.data?.props.topUser.length < 4) {
    lastArrayInApi.shift();
  }

  var state;
  const Options =
  {
    plugins: {
      title: {
        display: false,
        fontSize: 20,
      },
      legend: {
        display: false,
      }
    }
  }

  return (
    <>
      {props.topUser && props.topUser.slice(0, 5).map((item, index) => (
        <div className="chart-sidebar col-12 pl-0  ">
          <div className="col-md-5 col-12  pr-0 content-sidebar">
            <div className="d-flex ">
              <div className="img-user">
                <img
                  src={
                    item.picture
                      ? `${BaseUrlFiles}/${item.picture}`
                      : noImg
                  }
                  alt="imgMain"
                />
              </div>
              <div className="mr-2">
                <p className="m-3">{item.name}</p>

              </div>
            </div>
          </div>

          <div className="col-md-7 col-12 my-4 my-md-0 pr-0">
            <Line
              data={{
                labels: item?.perChart?.map((chart, index) => {
                  var timestamp = chart.date;
                  var a = new Date(timestamp * 1000);
                  var days = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'S'];
                  var dayOfWeek = days[a.getDay()]
                  return (dayOfWeek)
                }),

                datasets: [
                  {
                    label: '',
                    fill: true,
                    lineTension: 1,
                    backgroundColor: "transparent",
                    borderColor: "#f4b8b8",
                    borderWidth: 2,
                    data: item?.perChart?.map((chart) => chart.xp),

                  },
                ],
              }}
              options={Options}
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default ChartSidebar;
